import {
  SET_INGREDIENT_REPLACEMENT_MODAL_STATE,
  SET_INGREDIENT_REPLACEMENT_STEP,
  EDITABLE_INGREDIENT_REPLACEMENT_ROW
} from "actions/ingredientReplacement";
import { ingredientReplacementSteps } from "constants/ingredientReplacement";

const initialState = {
  step: ingredientReplacementSteps.INGREDIENT_REPLACEMENT_STEP,
  isIngredientReplacementModalOpen: false,
  editableIngredientReplacementRowId: null,
  editableIngredientReplacementItem: null,
};

const actionsMap = {
  [SET_INGREDIENT_REPLACEMENT_MODAL_STATE]: (state, action) => {
    const { isOpen } = action.payload;

    return {
      ...state,
      isIngredientReplacementModalOpen: isOpen,
    };
  },
  [SET_INGREDIENT_REPLACEMENT_STEP]: (state, action) => {
    return {
      ...state,
      step: action.payload.step,
    };
  },
  [EDITABLE_INGREDIENT_REPLACEMENT_ROW]: (state, action) => {
    return {
      ...state,
      editableIngredientReplacementRowId: action.payload.editableIngredientReplacementRowId,
      editableIngredientReplacementItem: action.payload.editableIngredientReplacementItem,
    };
  },
};

export default function ingredientReplacement(
  state = initialState,
  action = {}
) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
